import { CustomPrimaryUser } from 'api';
import { ResponsibleUser } from './types';

const getResponsibleUserLabel = (user: Pick<CustomPrimaryUser, 'first_name' | 'last_name'>) =>
  `${user.first_name ?? ''} ${user.last_name ?? ''}`.trim();

export const mergeResponsibleUsers = (...sources: Array<CustomPrimaryUser[] | undefined>): ResponsibleUser[] => {
  const responsibleUsersById = new Map<number, ResponsibleUser>();

  sources.flat().forEach(user => {
    if (!user?.id) {
      return;
    }

    const existingUser = responsibleUsersById.get(user.id);

    responsibleUsersById.set(user.id, {
      value: user.id,
      label: getResponsibleUserLabel(user),
      email: user.email,
      isPrimaryContact: (existingUser?.isPrimaryContact ?? false) || !!user.is_primary_contact,
    });
  });

  return Array.from(responsibleUsersById.values());
};
